import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      refetchOnWindowFocus: false,
      staleTime: 10 * 60 * 1000, // 10 minutes - data doesn't change often
      gcTime: 10 * 60 * 1000, // 10 minutes garbage collection time (formerly cacheTime)
    },
    mutations: {
      retry: 1,
    },
  },
});
